import React from 'react';

import type { StickyType } from '@core/StickyScroll';

import type { DialogColor, DialogVariant } from './styles';

export type DialogContextType = {
  color: DialogColor;
  invert: boolean;
  variant: DialogVariant;
  headingGroupId?: string;
  sticky: StickyType;
};

const defaultContext: DialogContextType = {
  color: 'white',
  invert: false,
  variant: 'standard',
  sticky: 'none',
};

const DialogContext = React.createContext<DialogContextType>(defaultContext);

export const useDialogContext = (): DialogContextType => {
  return React.useContext(DialogContext);
};

type Props = { children?: React.ReactNode } & Omit<DialogContextType, 'invert'>;

export const DialogContextProvider = ({
  color,
  headingGroupId,
  variant,
  children,
  sticky,
}: Props) => {
  const context = React.useMemo(
    () => ({
      color,
      headingGroupId,
      variant,
      invert: color !== 'white',
      sticky,
    }),
    [color, headingGroupId, variant, sticky]
  );

  return (
    <DialogContext.Provider value={context}>{children}</DialogContext.Provider>
  );
};
